var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"airportDetail"},[_c('div',{staticClass:"map"},[_c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{
        lat: _vm.info.lat,
        lng: _vm.info.lon
      },"zoom":11}},[_c('GmapMarker',{attrs:{"position":{
          lat: _vm.info.lat,
          lng: _vm.info.lon
        }}})],1)],1),_c('div',{staticClass:"info"},[_c('p',{staticClass:"localtime colorGrey"},[_vm._v(_vm._s(_vm.localtime(_vm.info.localtime)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }